export default __webpack_public_path__ + "static/media/about-years-02.e515d308.png";